// extracted by mini-css-extract-plugin
module.exports = {"featureList":"featureList_featureList__jx0yo"};